import React from 'react';

/** Official square mark only — do not fall back to legacy hawk SVG (wrong brand). */
const logoSrc = `${process.env.PUBLIC_URL || ''}/h2s-sqr-logo.png`;

const HawkIcon = ({ size = 24, className = '', ...props }) => (
  <img
    src={logoSrc}
    alt="Hack2skill"
    width={size}
    height={size}
    className={className}
    style={{
      width: size,
      height: size,
      objectFit: 'contain',
      display: 'block'
    }}
    {...props}
  />
);

export default HawkIcon; 